<footer class="footer" id="footer">
  <div class="made group">
    <img width="225" height="37" loading="eager" src="images/caseactive-full-logo.png" alt="caseactive-logo">
    <div class="made-desktop">
      <ng-container *ngTemplateOutlet="made"></ng-container>
    </div>
  </div>
  <div class="about">
    <div class="about-us group">
      <h3 class="group-name">{{ 'About Case Active' | translate }}</h3>
      <a routerLinkActive="active" [routerLink]="language === 'en' ? ['/'] : [language, '/']" class="group-item link">{{ 'Home' | translate }}</a>
      <a routerLinkActive="active" [routerLink]="language === 'en' ? ['overview'] : [language, 'overview']" class="group-item link">{{ 'Overview' | translate }}</a>
      <a routerLinkActive="active" [routerLink]="language === 'en' ? ['pricing'] : [language, 'pricing']" class="group-item link">{{ 'Pricing' | translate }}</a>
      <a routerLinkActive="active" [routerLink]="language === 'en' ? ['contact'] : [language, 'contact']" class="group-item link">{{ 'Contact us' | translate }}</a>
    </div>
  </div>
  <div class="about-resources group">
    <h3 class="group-name">{{ 'Resources' | translate }}</h3>
    <a routerLinkActive="active" [routerLink]="language === 'en' ? ['faq'] : [language, 'faq']" class="group-item link">{{ 'FAQ' | translate }}</a>
    <a routerLinkActive="active" [routerLink]="language === 'en' ? ['documentation'] : [language, 'documentation']" class="group-item link">{{ 'Support Documentation' | translate }}</a>
    <a routerLinkActive="active" [routerLink]="language === 'en' ? ['privacy-policy'] : [language, 'privacy-policy']" class="group-item link">{{ 'Privacy Policy' | translate }}</a>
    <a routerLinkActive="active" [routerLink]="language === 'en' ? ['terms-of-service'] : [language, 'terms-of-service']" class="group-item link">{{ 'Terms of Service' | translate }}</a>
  </div>
  <div class="to-app group">
    <h3 class="group-name">{{ 'App' | translate }}</h3>
    <a role="button" (click)="goToLogin()"  class="group-item link">{{ 'Log In' | translate }}</a>
    <a role="button" (click)="goToSignup()"  class="group-item link">{{ 'Get Started' | translate }}</a>
  </div>
  <!-- <div class="app">
    
  </div> -->
  <div class="made-mobile">
    <ng-container *ngTemplateOutlet="made"></ng-container>
  </div>
</footer>

<ng-template #made>
  <p class="group-item">{{ 'Made with' | translate }} 💙️ {{ 'in New York City' | translate }}</p>
  <p class="group-item">&copy; CaseActive {{ currentYear }}</p>
  <p class="group-item">{{ 'All rights reserved' | translate }}</p>
</ng-template>